window.addEventListener('load', function () {
    const placeholder = document.getElementById('related-deals-placeholder');
    if (!placeholder) return;

    const url = new URL(placeholder.dataset.url, window.location.origin);
    url.searchParams.set('count', placeholder.dataset.count);
    const pageParams = new URLSearchParams(window.location.search);
    ['term', 'mileage', 'initial_profile'].forEach(function (key) {
      if (pageParams.has(key)) url.searchParams.set(key, pageParams.get(key));
    });

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (response.status === 204) return '';
        if (!response.ok) throw new Error('Related deals request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (!html) {
          placeholder.remove();
          return;
        }

        placeholder.outerHTML = html;
        const section = document.getElementById('special-offers-strip');
        const slider = section.querySelector('.offers-strip-ctr');

        new Glider(slider, {
          slidesToScroll: 1,
          slidesToShow: 1,
          draggable: true,
          scrollLock: true,
          dots: section.querySelector('.dots'),
          arrows: {
            prev: section.querySelector('.glider-prev'),
            next: section.querySelector('.glider-next')
          },
          responsive: [
            { breakpoint: 959, settings: { slidesToShow: 2 } },
            { breakpoint: 1440, settings: { slidesToShow: 3 } }
          ]
        });

        if (window.initializeDealActions) window.initializeDealActions();
      })
      .catch(function (error) {
        placeholder.remove();
        console.error(error);
      });
  });
